import Vue from 'vue'
import App from './App.vue'
import WhatsAppButton from './components/whatsApp/WhatsAppButton.vue'
import VTooltip from 'v-tooltip'
import VModal from 'vue-js-modal'
import Vue2TouchEvents from 'vue2-touch-events'
import vuescroll from 'vuescroll'
import './themes.scss'

Vue.use(VTooltip)
Vue.use(VModal)
Vue.use(Vue2TouchEvents)
Vue.use(vuescroll, {
  ops: {
    vuescroll: {},
    scrollPanel: {
      scrollingX: false
    },
    rail: {},
    bar: {
      keepShow: true,
      background: '#a9a9a9'
    }
  },
  name: 'vuescroll'
})

export const serverUI = new Vue()

const divWebchat = document.getElementById('webchat')
const divWhatsappButton = document.getElementById('GBwhatsAppButton')

if (divWebchat) {
  new Vue({
    el: '#webchat',
    render: (h) => h(App)
  })
}

if (divWhatsappButton) {
  new Vue({
    el: '#GBwhatsAppButton',
    render: (h) => h(WhatsAppButton)
  })
}
